export default __webpack_public_path__ + "static/media/home-background.f6ef8619.png";